import { useCallback, useEffect, useState } from 'react';
import { Link, Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { logError } from '../../../../utils/logger';
import { SectionTitle, SegmentedControl } from '../../../shared/components';
import { getAllApplicants } from '../candidates.service';
import CandidatesTable from '../components/CandidatesTable';

const DEFAULT_STATUS = 'applied';
const STATUS_FILTERS = [
  { label: 'Applied', value: 'applied' },
  { label: 'Scheduled', value: 'scheduled' },
  { label: 'Rejected', value: 'rejected' },
];

export default function CandidatesPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const [applicants, setApplicants] = useState({});

  const status = searchParams.get('status') || DEFAULT_STATUS;

  const handleStatusChange = (val) => {
    if (val === status) return;
    navigate(`/candidates?status=${val}`, { replace: true });
  };

  const fetchAllCandidates = useCallback(async () => {
    if (!hasLoadedOnce) {
      setLoading(true);
    }
    try {
      const data = await getAllApplicants();
      setApplicants(data);
      setHasLoadedOnce(true);
    } catch (error) {
      toast.error(
        logError({
          message: 'Failed to fetch candidates',
          error: error,
          code: 'CANDIDATE_FETCH_FAILED',
        }),
      );
      setApplicants({});
    } finally {
      if (!hasLoadedOnce) setLoading(false);
    }
  }, [hasLoadedOnce]);

  useEffect(() => {
    fetchAllCandidates();
  }, [fetchAllCandidates]);

  return (
    <div className='column gap-5'>
      <Link to='/hiring-request/new' target='_blank' className='btn cta-outlined-btn self-end'>
        + Hiring Request
      </Link>
      <SegmentedControl options={STATUS_FILTERS} value={status} onChange={handleStatusChange} />
      <SectionTitle title='LIVE CANDIDATES' />
      <CandidatesTable candidatesData={applicants} status={status} loading={loading} />
      <Outlet context={{ refreshCandidates: fetchAllCandidates }} />
    </div>
  );
}
